// The server never echoes a stored secret, so an empty replace-only input
// needs another way to say "a value is on file" - these dots are it. Every
// credential block shows the same thing, so the shape lives in one place.
export const SECRET_ON_FILE = String.fromCharCode(8226).repeat(12);
